import storageSession from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';
import negocioReducer from './negocio';

const persistConfig = {
    key: 'negocio',
    storage: storageSession,
    whitelist: ['negocioDoUsuario'], 
};

const persistedNegocioReducer = persistReducer(persistConfig, negocioReducer);

export default persistedNegocioReducer;
